import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { Events } from 'app/core/events';
import { logger } from '../../../../core/utils/console';
import { APIGestaCardService } from 'app/core/api/gestacard.service';
import { ArquivoAnalisado, ExameUltrasom } from 'app/core/interfaces/pacient-info.interface';

@Component({
  selector: 'app-ultrasonografias',
  templateUrl: './ultrasonografias.component.html',
  styleUrls: ['./ultrasonografias.component.scss', './../tabelas.scss']
})
export class UltrasonografiasComponent implements OnInit {

  displayedColumns: string[] = ['data', 'ig', 'peso_fetal', 'placenta', 'outros'];
  dataSource: ExameUltrasom[] = [];
  arquivosPDFAnalisados: Array<{label: string, id: string, data: any, status: string}> = [];
  loadingArquivoId: string | null = null;
  deletingArquivoId: string | null = null;

  @Input() ultrasom;
  @Input() organizacao;
  @Input() cartao_id: string;
  @Input() encerrado: boolean = false;
  @Input('edit_mode') edit;
  @Input() arquivosAnalisados: ArquivoAnalisado[] = [];

  constructor(
    private events: Events,
    private _apiGestaCard: APIGestaCardService
  ) { }

  ngOnInit() {
    this.dataSource = this.ultrasom;
    this.updateDisplayedColumns();
    this._calcularArquivosPDF();
  }

  private updateDisplayedColumns(): void {
    this.displayedColumns = ['data', 'ig', 'peso_fetal', 'placenta', 'outros'];

    if (this.edit && !this.encerrado) {
      this.displayedColumns.push('acoes');
    }
  }

  private _calcularArquivosPDF(): void {
    const ultrassom = (this.arquivosAnalisados || []).filter(a => ['ultrassom', 'ultrasom'].includes(a.tipo));

    if (ultrassom.length > 0) {
      this.arquivosPDFAnalisados = ultrassom.map(a => ({
        label: 'USG Obstétrica',
        id: a.id,
        data: a.data_envio,
        status: a.status
      }));
    } else {
      // Fallback: derivar dos exames existentes (dados legacy)
      const ids = new Set<string>(
        ((this.dataSource || []) as ExameUltrasom[])
          .filter(u => !!u.arquivo_id)
          .map(u => u.arquivo_id as string)
      );
      this.arquivosPDFAnalisados = Array.from(ids).map(id => ({
        label: 'USG Obstétrica',
        id,
        data: null,
        status: 'utilizado'
      }));
    }
  }

  InserirUltrassonografia() {
    this.events.publish('ExameUltrassonografiaIncluir');
  }

  ngOnChanges(changes: SimpleChanges) {
    this.dataSource = this.ultrasom;
    this.updateDisplayedColumns();
    this._calcularArquivosPDF();
  }

  LerPDF() {
    this.events.publish('ExameUltrassonografiaIncluirPDF');
  }

  UtilizarArquivo(arquivoId: string): void {
    this.loadingArquivoId = arquivoId;
    this.events.publish('UtilizarArquivoUSG', {
      arquivoId,
      callback: (ultrasom: ExameUltrasom[]) => {
        this.dataSource = ultrasom;
        this._calcularArquivosPDF();
      },
      onFinish: () => {
        this.loadingArquivoId = null;
      }
    });
  }

  AnalisarArquivo(arquivoId: string): void {
    this.loadingArquivoId = arquivoId;
    this.events.publish('AnalisarArquivoUSG', {
      arquivoId,
      callback: (ultrasom: ExameUltrasom[]) => {
        this.dataSource = ultrasom;
        this._calcularArquivosPDF();
      },
      onFinish: () => {
        this.loadingArquivoId = null;
      }
    });
  }

  async AbrirPDF(arquivoId: string): Promise<void> {
    this.events.publish('AbrirArquivoAnalisado', arquivoId);
  }

  async ExcluirPDF(arquivoId: string): Promise<void> {
    const confirmar = window.confirm('Deseja excluir este PDF analisado?');
    if (!confirmar) return;

    this.deletingArquivoId = arquivoId;

    try {
      await this._apiGestaCard.DeletarArquivoPDF(arquivoId);

      this.arquivosAnalisados = (this.arquivosAnalisados || []).filter(arquivo => arquivo.id !== arquivoId);
      this._calcularArquivosPDF();
    } catch (err) {
      logger.error('Erro ao excluir PDF analisado:', err);
    } finally {
      this.deletingArquivoId = null;
    }
  }

  RemoverUSG(exame: ExameUltrasom): void {
    this.events.publish('ExameUltrassonografiaRemover', {
      exame,
      callback: (ultrasom: ExameUltrasom[]) => {
        this.dataSource = ultrasom;
      }
    });
  }

}
